import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Typography,
  Grid,
} from "@material-ui/core";
import { GetApp } from "@material-ui/icons";

function AchievementExportModal(props) {
  const { exporting, setExporting, handleExportData } = props;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const payload = {
        modelName: "achievement",
        profileId: 0,
        departmentId: 0,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
      };

      await handleExportData(payload);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setStartDate("");
      setEndDate("");
      setExporting(false);
    }
  };

  return (
    <Dialog open={exporting} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Xuất dữ liệu giải thưởng</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Xuất dữ liệu giải thưởng
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Từ ngày"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              variant="outlined"
              size="small"
              disabled={loading}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Đến ngày"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              variant="outlined"
              size="small"
              disabled={loading}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: "block" }}>
          * Để trống để xuất tất cả dữ liệu
        </Typography>
      </DialogContent>
      <DialogActions style={{ padding: "8px 24px 16px" }}>
        <Button onClick={handleClose} disabled={loading}>
          Hủy
        </Button>
        <Button
          onClick={handleExport}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <GetApp />}
        >
          {loading ? "Đang xuất..." : "Xuất Excel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AchievementExportModal;

